import { getVariantFromId } from "@input-output-hk/essential-cardano-utils";

const shapes = ["spire", "horizontal", "wave"] as const;
export const getItemLineShapeFromId = (_id: string) =>
  getVariantFromId(_id, shapes);
